import React from "react";
import { Pagination, download, plusIcon } from "../../Components";
import TokenItem from "./TokenItem";

export default function TokenTransactionDetail({
  subscriptionDetails,
  onPaginate,
  paginationDataToken,
  tokenAvailable,
  setModalAddToken,
  downloadCsv,
  tokenTransaction,
}) {
  return (
    <div>
      <div className="tokenDetails">
        <div className="billing__row tokenrow">
          <div className="billing__col tokenSummary subscription !rounded-lg">
            <div className="tokenTotal">Current month: </div>
            <div className="tokenTotal">
              Used: {tokenAvailable ? tokenAvailable.used : "NA"}
            </div>
            <div className="tokenAvailable">
              <div className="paddingSubscribetop">
                Available:{" "}
                {tokenAvailable
                  ? parseInt(tokenAvailable.available) -
                    parseInt(tokenAvailable.used) +
                    " / " +
                    tokenAvailable.available
                  : "NA"}
              </div>
              {subscriptionDetails &&
                subscriptionDetails.end_date !== "" &&
                subscriptionDetails.cancelurl !== "" && (
                  <button
                    className="button tertiary big addTokenButton"
                    onClick={() => setModalAddToken("addToken")}
                  >
                    Add token {plusIcon}
                  </button>
                )}
            </div>
          </div>
        </div>
      </div>
      <div className="billing__table tokenRowDetails !rounded-lg">
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Charge type</th>
              <th>Description</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {tokenTransaction.length > 0 ? (
              <>
                {tokenTransaction.map((item, index) => {
                  return <TokenItem key={index} {...item} />;
                })}
              </>
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  No records
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="billing__table-footer">
        <button className="button tertiary download" onClick={downloadCsv}>
          Download CSV {download}
        </button>
        {tokenTransaction.length > 0 && (
          <Pagination
            perPage={paginationDataToken["per_page"]}
            total={paginationDataToken["total"]}
            currentPage={paginationDataToken["current_page"]}
            totalPages={paginationDataToken["total_pages"]}
            onPaginate={onPaginate}
          />
        )}
      </div>
    </div>
  );
}
